import React from 'react'
import { FormattedMessage, useIntl } from 'gatsby-plugin-intl'

// Gatsby page data can contain an older, empty translation.
const FALLBACK_MESSAGES = {
  pl: 'Brak ofert spełniających wybrane kryteria. 😔',
  en: 'No offers match the search criteria 😔',
  de: 'Keine Angebote, die den ausgewählten Kriterien entsprechen. 😔'
}

const NoOffersMessage = () => {
  const intl = useIntl()

  return (
    <FormattedMessage
      id='offers.noOffers'
      defaultMessage={FALLBACK_MESSAGES[intl.locale] || FALLBACK_MESSAGES.pl}
    />
  )
}

export default NoOffersMessage
